export const PropertyRefNumFormFieldIdEnum= {
    formFieldId: 120648,
  };